/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import "leaflet/dist/images/marker-icon.png";
import "leaflet/dist/images/marker-icon-2x.png";
import "leaflet/dist/images/marker-shadow.png";

export default class OsmMap {

    constructor(
        id = 'seila-adherent-map',
        markers = [],
        zoom = 8
        ) {

        // Créer l'objet "myMap" et l'insèrer dans l'élément HTML qui a l'ID "map"
        this.mapMarkers = markers;
        this.zoom = zoom;
        this.mapContainer = id;
        this.myMap = L.map(this.mapContainer).setView([this.mapMarkers[0].lat, this.mapMarkers[0].lon], this.zoom);


        // Leaflet ne récupère pas les cartes (tiles) sur un serveur par défaut. Nous devons lui préciser où nous souhaitons les récupérer. Ici, openstreetmap.fr
        L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
            // Il est toujours bien de laisser le lien vers la source des données
            attribution: 'données © <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - rendu <a href="//openstreetmap.fr">OSM France</a>',
            minZoom: 1,
            maxZoom: 20
        }).addTo(this.myMap);

        this.markersLatLong = [];
        var LeafIcon = L.Icon.Default.extend({
//            options: {
//                iconUrl: '../img/marker-icon-2x.png',
//                shadowUrl: '../img/marker-shadow.png',
//            }
        });

        // Nous parcourons la liste des villes
        for (var marker in this.mapMarkers) {
            var mapMarker = L.marker([this.mapMarkers[marker].lat, this.mapMarkers[marker].lon], {icon: new LeafIcon()}).addTo(this.myMap);
            mapMarker.bindPopup(this.mapMarkers[marker].data);
            this.markersLatLong.push([this.mapMarkers[marker].lat, this.mapMarkers[marker].lon]);
        }

        if (this.mapMarkers.length > 1) {
            window.addEventListener("resize", this.pcrsStoresMapResizeMap.bind(this));        
            this.pcrsStoresMapResizeMap();
        }
    }

    pcrsStoresMapResizeMap() {
        this.myMap.fitBounds(this.markersLatLong);
    }
    
};
